import {getToken, isLogged, setLogged, notHasPermissions} from '../utils/auth';
import router from '../routes/index';
import Vue from 'vue'
import Swal from "sweetalert2";
import {localization, publicLocalization} from '../mixins/mixins';

// import * as helper from  '../mixins/mixins'

const axios = require('axios');
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 150000000, // Request timeout
});

// Request intercepter
service.interceptors.request.use(
  config => {
    const token = isLogged();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + getToken();
      config.headers['Accept'] = 'application/json';
      if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
        delete config.headers['Content-Type'];
      } else {
        config.headers['Content-Type'] = 'application/json';
      }
    }
    return config;
  },
  error => {
    // Do something with request error

    let message = error.message;
    console.log('-eror',error);
    console.log('-message',message);
    if (error.response.data && error.response.data.errors) {
      message = error.response.data.errors;
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    }

    if (error.response.status !== 401 && error.response.status !== 404) {

    }
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    // }

    return response.data;
  },
  error => {
    const responseData = error.response && error.response.data;
    if (typeof Blob !== 'undefined' && responseData instanceof Blob) {
      return responseData.text().then((text) => {
        let parsed = null;
        try {
          parsed = text ? JSON.parse(text) : null;
        } catch (e) {
          parsed = null;
        }

        if (parsed) {
          error.parsedBlobError = parsed;
          error.response.data = parsed;
        }

        const blobMessage = parsed && (
          parsed.message
          || (typeof parsed.error === 'string' ? parsed.error : null)
        );

        if (error.response.status !== 401 && error.response.status !== 404 && blobMessage && blobMessage != "LCI error message") {
          error.blobErrorToasted = true;
          Swal.fire({
            icon: 'error',
            text: isLogged() ? `${localization(blobMessage)}` : `${publicLocalization(blobMessage)}`,
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          });
        }

        if (error.response.status === 401 && !notHasPermissions()) {
          setLogged('2');
          router.push('/401');
        }

        return Promise.reject(error);
      });
    }

    let message = error.response.data;
    if (error.response.data && error.response.data.message) {
      message = error.response.data.message;
    } else if (error.response.data && error.response.data.error) {
      message = error.response.data.error;
    } else if (error.response.data && error.response.data.message) {
      message = error.response.data.message;
    }

    if (error.response.status !== 401 && error.response.status !== 404 && message != "LCI error message" ) {

      if (message) {
        console.log('===================================------------------------------>>>>>>>>>>>>> ', isLogged());
        Swal.fire({
          icon: 'error',
          text: isLogged() ? `${localization(message)}` : `${publicLocalization(message)}`,
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      } else {
        Swal.fire({
          icon: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }
    }
    if ((error.response.status === 404 && !message) || (error.response.status === 404 && !message.name)) {
      router.push('/404');
    }
    if (error.response.status === 401 && !notHasPermissions()) {
      setLogged('2');
      router.push('/401');
    }
    return Promise.reject(error);
  }
);

export default service;
